const actions = {

  employeeForTask({ commit, dispatch }, payload) {
    commit('setEmployeeList', payload);
  },
};

export default actions;
